// extracted by mini-css-extract-plugin
module.exports = {"author_image_wrap":"PostCard_author_image_wrap__pX8Gv","author_image":"PostCard_author_image__SPn23"};